export default function WeatherForecast() {
  return <div className="weather-forecast">Forecast will be here</div>;
}
